/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import MuiStylesIndicationsPage from "~/components/indicationsPage/MuiStylesIndicationsPage";
import { useSelector } from "react-redux";
import { Button, Typography, Box, List, ListItem, ListItemText, ListItemIcon, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import Footer from "~/components/common/footerContainer/FooterContainer";
import { withRouter } from "react-router-dom";
import { Gift } from "~/components/common/icons/Icons";
import { getGeneratedHash } from "~/services/referearnService";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import { useTranslation } from "react-i18next";
import { DialogBuilder } from "~/utils/DialogProvider";
import Utils from "~/helpers/Utils";

const Indications = (props) => {
	const [generatedHashURL, setGeneratedHashURL] = useState("");
	const [generatedHash, setGeneratedHash] = useState("");
	const [cashbackValue, setCashBackValue] = useState(0);
	const { business } = useSelector((store) => store?.business);
	const [loading, setLoading] = useState(false);
	const classes = MuiStylesIndicationsPage();
	const { me } = useSelector((store) => store.me);
	const { user } = useSelector((store) => store.auth);
	const { t, i18n } = useTranslation();
	const dialog = useContext(DialogBuilder);

	const copyReferralLink = () => {
		const tempInput = document.createElement("input");
		tempInput.value = generatedHashURL;
		document.body.appendChild(tempInput);

		tempInput.select();
		tempInput.setSelectionRange(0, 99999);

		document.execCommand("copy");

		document.body.removeChild(tempInput);

		dialog
			.withTitle(t("Link copied!"))
			.withMessage(t("The link has been copied just paste and send"))
			.withButtonText(t("OK"))
			.withContent(({ onClose }) => (
				<>
					<DialogTitle
						style={{
							textAlign: "center",
						}}>
						{t("Link copied!")}
					</DialogTitle>
					<DialogContent>
						<DialogContentText
							style={{
								textAlign: "center",
							}}>
							{t("The link has been copied just paste and send")}
						</DialogContentText>
					</DialogContent>
					<DialogActions style={{ justifyContent: "center", flexDirection: "column" }}>
						<Button
							variant="contained"
							onClick={() => {
								shareViaWhatsApp();
								mixpanelTrackEvent('Compartilhou_Via_WhatsApp', me || user, {});
								onClose();
							}}
							className={classes.shareButton}>
							{t('Share')}
						</Button>
						<Button
							style={{ color: "#3689ea", textTransform: "none", marginTop: "8px" }}
							onClick={onClose}>
							{t("OK")}
						</Button>
					</DialogActions>
				</>
			))
			.show();
	};

	const shareViaWhatsApp = () => {
		const message = `${t("share message link whatsapp")}\n\n${generatedHashURL}`;
		const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
		window.open(whatsappUrl, '_blank');
	};

	const handleEarningsClick = () => {
		props.history.push("/indicacoes/seus-ganhos", { hash: generatedHash });
	};
	const handleReferralsClick = () => {
		props.history.push("/indicacoes/suas-indicacoes");
	};
	const handleHowIndicationsWorkClick = () => {
		props.history.push("/indicacoes/como-funciona");
	};

	useEffect(() => {
		const fetchGeneratedHash = async () => {
			try {
				setLoading(true);
				const userId = localStorage.getItem("@prit-web/userId");
				const response = await getGeneratedHash(userId);
				setGeneratedHashURL(response.data.url_hash);
				setGeneratedHash(response.data.hash);
				setCashBackValue(response.data.cashback_value);

				setLoading(false);
			} catch (error) {
				setLoading(false);
				localStorage.setItem("isCommingFromIndications", "true");

				console.error("Erro ao buscar o hash gerado", error);
				props.history.push(`/business/link/${business?.id}`);
			}
		};

		fetchGeneratedHash();
	}, []);

	const footer = () => {
		return <Footer section="indicacoes" />;
	};

	return (
		<div className={classes.background}>
			<TitleContainer 
			 	loading={loading} 
			 	headerStyle={{ boxShadow: "0", padding: "0" }} 
			 	footer={footer()}
			>
				<Box
					className={classes.mainGrid}
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						marginTop: "0rem",
						height: "100%",
					}}>
					<Gift className="gift-icon" />

					<Typography className={classes.title} gutterBottom align="left">
						{t("Earn {{cashBackValue}} for each new subscriber you refer", {
							cashBackValue: Utils.moneyMaskNew(cashbackValue, i18n.language, business?.currency),
						})}
					</Typography>
					<Typography variant="body1" gutterBottom align="left" className={classes.subtitle}>
						{t("invite someone to download Prit and earn up to cashback with each referral", {
							cashBackValue: Utils.moneyMaskNew(cashbackValue, i18n.language, business?.currency),
						})}
					</Typography>
					<List component="nav" aria-label="secondary mailbox folders">
						<ListItem button style={{ padding: "8px 0" }} className={classes.buttonList} onClick={handleReferralsClick}>
							<ListItemText primary={t("Your referrals")} />
							<ListItemIcon className={classes.iconList}>
								<ArrowForwardIosIcon />
							</ListItemIcon>
						</ListItem>
						<ListItem button className={classes.buttonList} onClick={handleEarningsClick}>
							<ListItemText primary={t("Your rewards")} />
							<ListItemIcon className={classes.iconList}>
								<ArrowForwardIosIcon />
							</ListItemIcon>
						</ListItem>
						<ListItem button className={classes.buttonList} onClick={handleHowIndicationsWorkClick}>
							<ListItemText primary={t("How referrals work")} />
							<ListItemIcon className={classes.iconList}>
								<ArrowForwardIosIcon />
							</ListItemIcon>
						</ListItem>
					</List>
				</Box>
				{generatedHashURL !== "" && (
					<Box className={classes.actionButtonsContainer}>
						<Button
							variant="contained"
							onClick={() => {
								copyReferralLink();
								mixpanelTrackEvent('Copiou_Link_Indique_E_Ganhe', me || user, {});
							}}
							className={classes.copyLinkButton}>
							{t('Copy Link')}
						</Button>
					</Box>
				)}
			</TitleContainer>
		</div>
	);
};

export default withRouter(Indications);
